export default "__VITE_ASSET__DzGBY0PK__"